module.exports = __webpack_public_path__ + "img/water1.94f4bfdc.jpg";